export default {
  formValues: {},
  formErrors: {},
  tip: null,
  tipSelection: '',
  serverError: null,
  submitting: false,
  busyWithPayPal: false,
};
